/**
 * PageAccessRoute - компонент для проверки доступа к страницам на основе матрицы из БД
 * Используется вместе с ProtectedRoute для дополнительной проверки прав
 */
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DeployStatusIndicator from './dashboard/DeployStatusIndicator';

const PageAccessRoute = ({ children, redirectTo = '/dashboard' }) => {
  const { user, hasPageAccess, loading, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Показываем загрузку пока проверяем авторизацию
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl">Загрузка...</div>
      </div>
    );
  }

  // Если не авторизован - на логин
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Проверяем доступ к текущему пути
  const currentPath = location.pathname;
  const allowed = hasPageAccess(currentPath);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!allowed) {
    // Показываем сообщение об отказе в доступе
    return (
      <div className="min-h-screen bg-gray-50">
        {/* Header с кнопкой выхода */}
        <div className="bg-white shadow-sm border-b">
          <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <span className="text-lg font-semibold text-gray-800">PCC</span>
              <span className="text-sm text-gray-500">|</span>
              <span className="text-sm text-gray-600">{user.full_name || user.email}</span>
              <span className="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded">{user.role}</span>
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
            >
              Выйти из системы
            </button>
          </div>
        </div>

        {/* Сообщение об отказе */}
        <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 60px)' }}>
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md text-center">
            <div className="text-6xl mb-4">🚫</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Доступ запрещён</h1>
            <p className="text-gray-600 mb-4">
              У вашей роли <strong className="text-purple-600">{user.role}</strong> нет доступа к этой странице.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Обратитесь к администратору для изменения прав доступа.
            </p>
            <button
              onClick={() => window.history.back()}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Вернуться назад
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <DeployStatusIndicator />
      {children}
    </>
  );
};

export default PageAccessRoute;
